import { useContext } from 'react';

import { ConnectivityContext } from 'contexts/Connectivity';

const useConnectivity = () => {
  return useContext(ConnectivityContext);
};

export default useConnectivity;
